import type { BootServices } from '../../bootstrap';
import { deductCredits, type DeductResult } from './credits';

function purchasedKey(modelId: number) {
  return `chat_purchased_model_${modelId}`;
}

function isV2Key(x: string): boolean {
  return /^(transition|once):/.test(String(x || ''));
}

export class Billing {
  private purchased = new Set<string>();

  loadPurchased(modelId: number) {
    this.purchased = new Set();
    try {
      const raw = localStorage.getItem(purchasedKey(modelId));
      if (!raw) return;
      const arr = JSON.parse(raw);
      if (Array.isArray(arr)) {
        const out = new Set<string>();
        let migrated = false;
        for (const x of arr) {
          const s = String(x || '').trim();
          if (!s) continue;
          // v1 legacy stored plain commandName. v2 stores `${kind}:${command}`.
          if (isV2Key(s)) out.add(s);
          else {
            migrated = true;
            // Best-effort migration: legacy purchase applied to both kinds (old UX didn't distinguish).
            out.add(`transition:${s}`);
            out.add(`once:${s}`);
          }
        }
        this.purchased = out;
        if (migrated) {
          try {
            localStorage.setItem(purchasedKey(modelId), JSON.stringify(Array.from(this.purchased)));
          } catch {}
        }
      }
    } catch {}
  }

  listPurchased(): string[] {
    return Array.from(this.purchased);
  }

  isPurchased(key: string): boolean {
    return this.purchased.has(String(key || '').trim());
  }

  markPurchased(modelId: number, key: string) {
    const k = String(key || '').trim();
    if (!k) return;
    if (this.purchased.has(k)) return;
    this.purchased.add(k);
    try {
      localStorage.setItem(purchasedKey(modelId), JSON.stringify(Array.from(this.purchased)));
    } catch {}
  }

  /**
   * Replace the local purchased set from server-authoritative list (cross-device).
   * Also persists to localStorage as a cache (best-effort).
   */
  replacePurchased(modelId: number, keys: string[]) {
    const arr = Array.isArray(keys) ? keys : [];
    const out = new Set<string>();
    for (const x of arr) {
      const s = String(x || '').trim();
      if (!s) continue;
      if (isV2Key(s)) out.add(s);
    }
    this.purchased = out;
    try {
      localStorage.setItem(purchasedKey(modelId), JSON.stringify(Array.from(this.purchased)));
    } catch {}
  }

  async deduct(args: { services: BootServices; amount: number; commandName: string; modelId: number }): Promise<DeductResult> {
    return await deductCredits(args);
  }
}


